import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useOpenableControls } from '../../../../generic-hooks'

import { useBarcodeTypesTranslationMap } from './useBarcodeTypesTranslationMap'

interface ProductKeyFactBarcodeInfoProps {
  content: string
  showExplanationIcon?: boolean
}

export const ProductKeyFactBarcodeInfo: FC<ProductKeyFactBarcodeInfoProps> = ({
  content,
  showExplanationIcon = true,
}) => {
  const intl = useIntl()
  const { handleClose, handleOpen, isOpen } = useOpenableControls(false)

  const barcodeTypesTranslationMap = useBarcodeTypesTranslationMap()

  return (
    <>
      <span data-qa-id="product-attribute-pzn">{content}</span>
      {showExplanationIcon ? (
        <>
          <button
            aria-label={intl.formatMessage({
              id: 'product.barcodes.modal.headline',
            })}
            className="text-dark-brand hover:text-dark-hover-brand active:text-dark-pressed-brand"
            onClick={handleOpen}
            type="button"
          >
            <IconInfo className="ml-1 inline-block size-5 shrink-0 align-top" />
          </button>
          <Dialog onClose={handleClose} open={isOpen}>
            <DialogTitle onClose={handleClose}>
              <FormattedMessage id="product.barcodes.modal.headline" />
            </DialogTitle>
            <DialogContent>
              <ul>
                {barcodeTypesTranslationMap.map((translation, index) => (
                  // eslint-disable-next-line react/no-array-index-key -- can't use the value because it is a ReactNode
                  <li className="mb-4" key={index}>
                    {translation}
                  </li>
                ))}
              </ul>
            </DialogContent>
          </Dialog>
        </>
      ) : null}
    </>
  )
}
